type SiteHeaderProps = {
  badge?: string | undefined;
  badgeDescription?: string | undefined;
};

export function SiteHeader({ badge, badgeDescription }: SiteHeaderProps) {
  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <a className="brand" href="/" aria-label="Entangled Vega home">
        <span className="brand__mark" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
        <span>
          <strong>Entangled Vega</strong>
          <small>Public-figure connection atlas</small>
        </span>
      </a>
      <nav className="site-nav" aria-label="Primary navigation">
        <a href="/challenge/">Daily connection</a>
        <a href="/about">About</a>
        <a href="/privacy">Privacy &amp; legal</a>
        {badge === undefined ? null : (
          <span
            className="build-badge"
            title={badgeDescription}
            aria-label={badgeDescription === undefined ? badge : `${badge}. ${badgeDescription}`}
          >
            {badge}
          </span>
        )}
      </nav>
    </header>
  );
}
